import { createSlice } from "@reduxjs/toolkit";

export type Session = {
  uuid: string;
  user: number;
  expiry: null;
  id: number;
  workflowId: number;
  deal: string;
};

const initialState = {
  stepNumber: 1,
  totalSteps: 1,
  canGoBack: true,
  loading: false,
  session: {
    uuid: "",
    user: 0,
    expiry: null,
    id: 0,
    workflowId: 0,
    deal: "",
  } as Session,
  user: {
    id: 0,
    createdAt: "",
    updatedAt: "",
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    pandacontact: null,
    paymentmethodid: null,
    status: "",
  },
  steps: {},
};

const stepObject = (steps: any) => {
  if (+Object.keys(steps).sort((a, b) => +a - +b)[0] === 1) {
    // steps is an object with non-0 first index,
    // - and is not an array, since key of [0] is always … 0
    return steps;
  }

  try {
    const out = {} as any;
    steps.map((s: any) => {
      out[`${s.order}`] = s;
    });
    return out;
  } catch {
    const out = {} as any;
    Object.keys(steps).forEach((key) => {
      const entry = steps[key];
      const newKey = `${entry?.order}`;
      out[newKey] = entry;
    });

    return out;
  }
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setState: (state, action) => {
      const { stepNumber, canGoBack, user, steps, session } = action.payload;
      console.log("setState incoming session", session);
      state.stepNumber = stepNumber;
      state.canGoBack = canGoBack;
      state.user = user;

      const newSteps = {} as any;
      const curStepObject = stepObject(JSON.parse(JSON.stringify(state.steps)));

      const newStepObject = stepObject(JSON.parse(JSON.stringify(steps)));

      Object.keys(state.steps).forEach((k: string) => {
        const orig = curStepObject[k] as any;
        const owrite = newStepObject[k];
        newSteps[`${k}`] = { ...orig, ...owrite };
      });

      state.steps = newSteps;
      state.totalSteps = Object.keys(newSteps).length;

      state.session = { ...state.session, ...session };
    },
    nextStep: (state) => {
      state.stepNumber = state.stepNumber + 1;
    },
    previousStep: (state) => {
      state.stepNumber = state.stepNumber - 1;
    },
    setCanGoBack: (state, action) => {
      state.canGoBack = action.payload;
    },
    setStepState: (state, action) => {
      const { step, data } = action.payload;
      if (typeof step !== "undefined") {
        // @ts-ignore
        state.steps[step] = { ...state.steps[step], ...data };
      }
    },
    setSteps: (state, action) => {
      const { steps } = action.payload;
      const newSteps = stepObject(steps);
      state.steps = newSteps;
      state.totalSteps = Object.keys(newSteps).length;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setSession: (state, action) => {
      console.log("setSession", action.payload);
      state.session = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const {
  nextStep,
  previousStep,
  setCanGoBack,
  setStepState,
  setSteps,
  setUser,
  setState,
  setSession,
  setLoading, // used to force app to show the loaded when not submitting a form
} = slice.actions;

export default slice.reducer;
